import LazyVideo from '@/components/lazy-video';
import {
  curriculumPointData,
  moCurriculumPointData,
} from '@/data/recommend-class/recommend-class.data';

export default function CommonBrandStory() {
  return (
    <>
      <div className="desktop:px-0 px-5">
        <div className="mobile-w desktop:web-w desktop:mx-auto desktop:w-full box-border h-auto w-[327px] overflow-hidden rounded-lg">
          <LazyVideo
            src="/videos/top_mo.mp4"
            poster="/images/brandstory/video_top_mo.png"
            muted
            loop
            playsInline
            autoPlay
            controls={false}
          />
        </div>
      </div>
      {/**웹 */}
      <div className="desktop:grid desktop:gap-6 desktop:grid-cols-2 desktop:mt-10 desktop:mb-40 hidden grid-cols-1 gap-4">
        {curriculumPointData.map((item) => (
          <div
            key={item.label}
            className="desktop:w-[578px] desktop:h-[288px] relative h-[227px] w-[327px]"
            style={{
              backgroundImage: `url(${item.imageSrc})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="desktop:px-[32px] desktop:py-[40px] box-border flex flex-col">
              <div className="typo-14 desktop:typo-18 text-main-orange desktop:mb-[16px] font-extrabold">
                {item.label}
              </div>
              <div className="typo-20 desktop:typo-28 desktop:mb-[10px] font-bold">
                {item.title1}
              </div>
              <div className="typo-20 desktop:typo-28 desktop:mb-[14px] font-black">
                {item.title2}
              </div>
              <div className="typo-16 desktop:typo-20 desktop:leading-relaxed font-semibold">
                <p dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          </div>
        ))}
      </div>
      {/**모바일 */}
      <div className="desktop:hidden mt-7 mb-[100px] grid grid-cols-1 gap-6">
        {moCurriculumPointData.map((item) => (
          <div
            key={item.label}
            className="desktop:w-[578px] desktop:h-[288px] relative h-[227px] w-[327px] rounded-[10px] border border-[#111111]/10"
            style={{
              backgroundImage: `url(${item.imageSrc})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="box-border flex flex-col px-[22px] py-[24px]">
              <div className="typo-14 text-main-orange mb-[12px] font-extrabold">
                {item.label}
              </div>
              <div className="typo-20 mb-[6px] font-bold">{item.title1}</div>
              <div className="typo-20 mb-[14px] font-black">{item.title2}</div>
              <div className="typo-16 leading-normal font-semibold">
                <p dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
